/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m19.166 8.828 2.585 2.583a.807.807 0 0 1 0 1.167l-2.585 2.583c-.499.501-1.416.167-1.416-.583v-1.583a.18.18 0 0 0-.166-.167h-4.726a2.501 2.501 0 0 1-4.716 0H2.833c-.5 0-.833-.333-.833-.833 0-.5.333-.834.833-.834h5.31a2.501 2.501 0 0 1 4.715 0h4.726a.18.18 0 0 0 .166-.166V9.41c0-.75.917-1.083 1.416-.583Z"
})), "0 0 24 24", "RouteOneStop");